// export const apiurl = "http://192.168.5.94:5000"
    export const apiurl = "https://branchbe.mynt.in"
    export const ageingurl = "https://zsync.zebull.in/zebu/getuserdetailsByCode/ageing_calc"
    export const ageingurlo = "https://ekycbe.mynt.in/zebu/ageing_calc1"
    // export const ageingurlo = "http://192.168.5.74:5001/zebu/ageing_calc1"

// export const apiurl = "http://192.168.5.73:5512"
// export const apiurl = "http://192.168.5.163:5512"